import zbTransfer from './transfer.vue'

export default zbTransfer
